document.querySelectorAll('[data-all-plp]').forEach((root) => {
  const form = root.querySelector('[data-all-filters]');
  const cards = [...root.querySelectorAll('[data-all-card]')];
  const grid = root.querySelector('[data-all-cards]');
  const count = root.querySelector('[data-all-count]');
  const empty = root.querySelector('[data-all-empty]');
  const sorts = [...root.querySelectorAll('[data-all-sort]')];
  const isGerman = document.documentElement.lang.toLowerCase().startsWith('de');
  const selected = (name) => [...form.querySelectorAll('input[name="' + name + '"]:checked')].map((input) => input.value);
  const variantMatches = (card, sizes, colors, packs, min, max) => {
    const names = card.dataset.optionNames.split('|').map((name) => name.toLocaleLowerCase());
    const indexFor = (pattern) => names.findIndex((name) => pattern.test(name));
    const sizeIndexes = names.map((name, index) => /größe|size|format|länge|length|breite|width/.test(name) && !/pack|menge|quantity|stück/.test(name) ? index : -1).filter((index) => index >= 0);
    const colorIndex = indexFor(/farbe|color|colour/);
    const packIndex = indexFor(/pack|menge|quantity|stück/);
    const variants = JSON.parse(card.querySelector('[data-variants]').textContent);
    return variants.some((variant) => {
      const options = [variant.option1, variant.option2, variant.option3];
      return variant.available !== false &&
        (!sizes.length || sizeIndexes.some((index) => sizes.includes(options[index]))) &&
        (!colors.length || (colorIndex >= 0 && colors.includes(options[colorIndex]))) &&
        (!packs.length || (packIndex >= 0 && packs.includes(options[packIndex]))) &&
        variant.price >= min && variant.price <= max;
    });
  };
  const update = () => {
    const categories = selected('category');
    const sizes = selected('size');
    const colors = selected('color');
    const packs = selected('pack');
    const min = Number(form.elements.min_price.value || 0) * 100;
    const max = form.elements.max_price.value ? Number(form.elements.max_price.value) * 100 : Infinity;
    let visible = 0;
    cards.forEach((card) => {
      const categoryMatches = !categories.length || categories.some((category) => card.dataset.categories.includes('|' + category + '|'));
      const matches = categoryMatches && variantMatches(card, sizes, colors, packs, min, max);
      card.hidden = !matches;
      if (matches) visible++;
    });
    count.textContent = visible + (isGerman ? (visible === 1 ? ' Produktlinie' : ' Produktlinien') : (visible === 1 ? ' product line' : ' product lines'));
    empty.hidden = visible > 0;
  };
  form.addEventListener('input', update);
  form.addEventListener('change', update);
  form.addEventListener('reset', () => requestAnimationFrame(() => { update(); applySort('featured'); }));
  const applySort = (value) => {
    sorts.forEach((select) => { select.value = value; });
    cards.sort((a, b) => value === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) : value === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) : Number(a.dataset.index) - Number(b.dataset.index));
    cards.forEach((card) => grid.append(card));
  };
  sorts.forEach((select) => select.addEventListener('change', () => applySort(select.value)));
  root.querySelector('[data-all-show]').addEventListener('click', () => root.querySelector('#product-grid').scrollIntoView({ behavior: 'smooth', block: 'start' }));
  update();
});
